import { parseLink } from "../../../../utils/linkParser/linkParser";
import { linksOf } from "../../../../services/cpln";
import { Base } from "../../../../schema/types/base";

export function WorkloadGVCTagFn<T extends Base>(withLabel: boolean): (item: T) => string {
  return (item) => {
    const prefix = withLabel ? "GVC: " : "";
    try {
      return prefix + parseLink(linksOf(item).self!, { useInputCtx: true }).gvc;
    } catch (e) {
      return "";
    }
  };
}
